import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface ITeamMember {
	image?: IImage;
	fullname?: string;
	position?: string;
	showLink?: boolean;
	link?: ILink;
}

export interface ITeamModuleProps extends IBaseElementProps {
	members?: ITeamMember[];
}

/**
 * Stats
 * @block
 * @requiresHooks
 * @icon groups
 */
const TeamModule: React.FC<ITeamModuleProps> = ({
	className,
	classNames = [],
	members = [],
}) => (
	<div className={className || cn('team-module', ...classNames)}>
		{members.map(({ image, fullname, position, link, showLink }, index) => (
			<div className="team-module__member" key={index}>
				<Image {...image} className="team-module__member__image" />
				<h3 className="team-module__member__name">{fullname}</h3>
				<div className="team-module__member__position">{position}</div>
				{showLink && (
					<Button {...link} className="team-module__member__link" />
				)}
			</div>
		))}
	</div>
);

export default TeamModule;
